import React, { useRef } from 'react';

import { ReactComponent as IconDropDownArrow } from '../../assets/svgs/icon-dropdown-arrow.svg';
import { useOutsideClick } from '../../hooks';
import { Pagination } from './Pagination';

interface Props {
  memberCountFiltered: number;
  pageSize: number;
  pageNumber: number;
  pageRangeDisplayed: number;
  showPageSizeDropdown: boolean;
  setPageSize: (pageSize: number) => void;
  setPageNumber: (pageNumber: number) => void;
  setShowPageSizeDropdown: (showPageSizeDropdown: boolean) => void;
}

export enum PaginationSize {
  Ten = 10,
  Twenty = 20,
}

export const PaginationRow: React.FC<Props> = ({
  memberCountFiltered,
  pageSize,
  pageRangeDisplayed,
  setPageSize,
  pageNumber,
  setPageNumber,
  showPageSizeDropdown,

  setShowPageSizeDropdown,
}) => {
  const listRef = useRef(null);
  const disableDropDown = memberCountFiltered < 11;

  useOutsideClick(listRef, () => {
    setShowPageSizeDropdown(false);
  });

  return (
    <div className="shadow absolute bottom-0 left-0 w-full p-4 px-8 bg-white flex flex-row justify-between border-t border-gray-100">
      <div className="flex flex-row items-center">
        <p className="text-gray-600 font-medium">Shows</p>
        <div className="relative" ref={listRef}>
          {showPageSizeDropdown && (
            <ul className="absolute bg-white border border-gray-300 mx-1 rounded bottom-8 w-5/6">
              <li
                onClick={() => {
                  setPageSize(PaginationSize.Twenty);
                  setShowPageSizeDropdown(false);
                }}
                className="cursor-pointer text-gray-600 font-semibold hover:bg-gray-100 py-2 border-b border-gray-200 text-center"
              >
                {PaginationSize.Twenty}
              </li>
              <li
                onClick={() => {
                  setPageSize(PaginationSize.Ten);
                  setShowPageSizeDropdown(false);
                }}
                className="cursor-pointer text-gray-600 font-semibold hover:bg-gray-100 py-2 text-center"
              >
                {PaginationSize.Ten}
              </li>
            </ul>
          )}
          <button
            onClick={() => {
              if (disableDropDown) {
                return;
              }
              setShowPageSizeDropdown(!showPageSizeDropdown);
            }}
            className={`${
              disableDropDown ? 'cursor-not-allowed' : ''
            } text-gray-600 font-semibold flex flex-row items-center mx-1 border border-gray-300 p-1 rounded w-5/6`}
          >
            {pageSize} <IconDropDownArrow className="ml-1 fill-current text-gray-600 h-2 w-2" />
          </button>
        </div>
        <p className="text-gray-600 font-medium">
          out of <span className="font-semibold">{memberCountFiltered} clients</span>
        </p>
      </div>
      <Pagination
        totalItemsCount={memberCountFiltered}
        itemsCountPerPage={pageSize}
        activePage={pageNumber}
        onChange={setPageNumber}
        pageRangeDisplayed={pageRangeDisplayed}
      />
    </div>
  );
};
